/** Player-facing combat text. */
export const combat = {
  "combat.exchange": "The exchange is unfolding…",
  "combat.arts": "Arts & prayer",
  "combat.artsReady": "Ready: {n}",
  "combat.loading": "The champions are entering the lists…",
  "combat.screen.arena": "The Lists",
  "combat.screen.advice": "Scribe’s Advice",
  "combat.screen.instruction": "How to Duel",
  "combat.screen.fight": "The Duel",
  "combat.screen.result": "The Verdict",
  "combat.screen.charter": "Challenge Charter",
  "combat.screen.tournament": "St Purr’s Tournament",
  "combat.screen.ladder": "The Ladder",
  "combat.screen.balance": "Balance",
  "combat.kicker": "CHAPTER II · HONOUR & BRUISES",
  "combat.lead": "For honour, glory, and the last herring.",
  "combat.choose": "Choose your rival",
  "combat.resume": "Resume the duel",
  "combat.duel": "Challenge",
  "combat.back": "Back to the Lists",
  "combat.home": "Return to your Chronicle",
  "combat.rules": "How to fight",
  "combat.record": "Wins {wins} · losses {losses}",
  "combat.rank": "Rung {n} / 12",
  "combat.rankHint": "Every victory climbs one rung. Defeat never takes your glory away.",
  "combat.noHistory": "The scribe has sharpened his quill. Your first duel awaits.",
  "combat.history": "Recent duels",
  "combat.foe.novice": "Hugo the Hare",
  "combat.foe.knight": "Sir Purr of the Pantry",
  "combat.foe.prior": "Prior Squint",
  "combat.foe.collector": "Reeve Shortchange",
  "combat.flavor.novice": "Challenges every carrot to single combat.",
  "combat.flavor.knight": "Firm guard. Less firm cheese principles.",
  "combat.flavor.prior": "Blesses with his left. Cheats with both.",
  "combat.flavor.collector": "Taxes your shadow. Charges the tail separately.",
  "combat.difficulty.novice": "Warm-up",
  "combat.difficulty.knight": "A fair match",
  "combat.difficulty.prior": "Formidable",
  "combat.difficulty.collector": "A costly bargain",
  "combat.reward": "Bounty ×{n}",
  "combat.habit": "Habit: {action}",
  "combat.mechanic.novice": "Every third turn: reckless rush. Guard stops it and opens a free turn with +25% damage.",
  "combat.mechanic.knight": "Two mail clasps block 4 damage each. Feint or Earthshatter breaks one permanently; an ultimate bypasses both.",
  "combat.mechanic.prior": "Warns one turn before a healing rite. Strike for 2 stamina or a special attack interrupts it. Otherwise he heals 18 instead of attacking.",
  "combat.mechanic.collector": "Every third turn: Strike and a levy of up to 24 fervour. Guard saves health; Feint saves fervour but takes a stronger hit. Spend before he collects.",
  "combat.phase.audit": "LEVY NEXT TURN · Budget your fervour. Now: {action}.",
  "combat.phase.levy": "LEVY · Strike; takes up to 24 fervour. Guard: less harm, pay. Feint: more harm, keep fervour.",
  "combat.levyDetails": "How the levy works",
  "combat.levyRule": "After costs and gains: he takes up to 24 fervour, even through Guard. Feint evades the levy, but not his Strike. An ultimate or Sigil tempest suppresses it. No debt, no gold lost; no collection if either fighter falls.",
  "combat.event.fervorTaken": "Stamped! Fervour −{n}.",
  "combat.event.levyEvaded": "Seal dodged. Your fervour stays yours.",
  "combat.event.levySuppressed": "Levy suppressed. No fervour taken.",
  "combat.phase.rush": "RECKLESS RUSH · Guard stops it and makes Hugo stumble next turn.",
  "combat.phase.stumbled": "STUMBLED · Hugo cannot answer this turn. Your damage +25%.",
  "combat.event.rushStopped": "Rush stopped! Hugo stumbles next turn.",
  "combat.phase.mail": "MAIL {n}/2 · Blocks {block} damage. Feint loosens one clasp. Next: {action}.",
  "combat.phase.unfastened": "MAIL OPEN · No armour reduction. Next: {action}.",
  "combat.event.armourBroken": "Clasp loosened! {n}/2 remain.",
  "combat.event.armourBlocked": "Mail absorbed {n}.",
  "combat.phase.prepare": "RITE NEXT TURN · Save 2 stamina to interrupt. Now: {action}.",
  "combat.phase.chant": "HEALING RITE · Strike or a special attack interrupts. Otherwise: +18 enemy HP, no attack.",
  "combat.event.interrupted": "Rite interrupted! No healing or reply.",
  "combat.event.foeHealed": "Prior heals +{n}.",
  "combat.round": "Turn {n}",
  "combat.you": "Your champion",
  "combat.health": "Health",
  "combat.intent": "Enemy prepares: {action}",
  "combat.heavy": "HEAVY BLOW · brace yourself",
  "combat.stamina": "Stamina {n}/{max}",
  "combat.fervor": "Fervour {n}/100",
  "combat.combo": "Counter streak ×{n}",
  "combat.action.strike": "Strike",
  "combat.action.guard": "Guard",
  "combat.action.feint": "Feint",
  "combat.action.prayer": "Prayer",
  "combat.action.signature": "Signature",
  "combat.action.starfall": "Starfall",
  "combat.action.thousandCuts": "Thousand Cuts",
  "combat.action.solarCleave": "Solar cleave",
  "combat.action.seismicSlam": "Earthshatter",
  "combat.action.tempest": "Sigil tempest",
  "combat.action.shadowDance": "Shadow dance",
  "combat.cost.technique": "{fervor} fervour · {stamina} stamina",
  "combat.nextDuelTechnique": "This weapon’s new technique will be available in your next duel.",
  "combat.presentation.reply": "Rival replies",
  "combat.presentation.block": "Protective sigils",
  "combat.presentation.shield": "Shield absorbs the blow",
  "combat.cost.fervor": "{fervor} fervour",
  "combat.hint.solarCleave": "Counters feint · preserves your streak",
  "combat.hint.seismicSlam": "Breaks one mail clasp · enemy can reply",
  "combat.hint.tempest": "Blocks the reply · +1 stamina",
  "combat.hint.shadowDance": "Keeps your streak · +2 stamina",
  "combat.hint.starfall": "Rise → star → meteor · 70 fervour",
  "combat.hint.thousandCuts": "Dash → 28 cuts → click · 70 fervour",
  "combat.event.shieldBlocked": "Equipment absorbed {n}.",
  "combat.event.techniqueBlocked": "Sigils blocked {n} damage.",
  "combat.event.staminaRestored": "Stamina +{n}.",
  "combat.hint.strike": "Beats feint · −2 stamina",
  "combat.hint.guard": "Catches strike · +2 stamina",
  "combat.hint.feint": "Bypasses guard · −1 stamina",
  "combat.hint.prayer": "Heal {heal} HP · 40 fervour · once per duel",
  "combat.hint.signature": "Double blow · 70 fervour",
  "combat.wait": "Choose your answer. Take your time.",
  "combat.counter": "Clever counter!",
  "combat.hit": "Dealt {dealt} · received {received}",
  "combat.heal": "Healing +{n}",
  "combat.win": "A glorious victory!",
  "combat.loss": "The ink is still wet",
  "combat.winSub": "The scribe has already made you an inch taller.",
  "combat.lossSub": "A bruised ego today. The experience and gold are still yours.",
  "combat.stats": "Turns: {rounds} · clever counters: {counters}",
  "combat.paid": "Experience and gold added to your Chronicle.",
  "combat.again": "Another duel",
  "combat.upgrade": "Train your champion",
  "combat.rule1": "Read your rival: guard catches strike, strike beats feint, feint bypasses guard.",
  "combat.rule2": "Attacks use stamina. Guard restores 2 stamina even when it is not the perfect answer.",
  "combat.rule3": "Clever counters build fervour and a stronger streak. Spend 40 to heal, 45–55 on your weapon technique, or 70 for an ultimate with no reply. Techniques spend fervour; they never generate it.",
  "combat.rule4": "Take your time: the duel waits for you. Keys 1–3 choose ordinary actions, 4 heals; 5–6 choose the displayed weapon moves, from left to right.",
  "combat.rule5": "Chronicle training helps in battle: might strengthens blows, grit adds health, cunning reduces incoming damage.",
  "combat.noDuel": "Choose a rival in the Lists to begin.",
  "combat.joke.0": "The scribe writes: “All according to plan.” Plan not attached.",
  "combat.joke.1": "Someone in the crowd wants their herring back.",
  "combat.joke.2": "The armour makes a more convincing argument.",
  "combat.joke.3": "St Purr pretends he is not watching.",
  "combat.joke.4": "The referee swallowed his whistle. Carry on.",
  "combat.joke.5": "A fine blow. Almost calligraphy."
} as const;
